export default __webpack_public_path__ + "static/media/DispositivosEmptystate.3ba0d3ad.svg";